export class CancellationNotAllowed extends Error {}

export class FeeRequired extends Error {}
export class RescheduleRequestRequired extends Error {}
